export const GRID = 64;
export const CENTER = GRID / 2;

export const px = (ctx: CanvasRenderingContext2D, x: number, y: number, color: string): void => {
  if (x < 0 || y < 0 || x >= GRID || y >= GRID) return;
  ctx.fillStyle = color;
  ctx.fillRect(Math.floor(x), Math.floor(y), 1, 1);
};

export const rect = (ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, color: string): void => {
  ctx.fillStyle = color;
  for (let i = 0; i < w; i++) for (let j = 0; j < h; j++) {
    const xx = Math.floor(x + i), yy = Math.floor(y + j);
    if (xx >= 0 && xx < GRID && yy >= 0 && yy < GRID) ctx.fillRect(xx, yy, 1, 1);
  }
};

export const cRect = (ctx: CanvasRenderingContext2D, y: number, w: number, h: number, color: string): void =>
  rect(ctx, CENTER - w / 2, y, w, h, color);

export const cSpine = (ctx: CanvasRenderingContext2D, y: number, h: number, color: string): void =>
  rect(ctx, CENTER - 1, y, 2, h, color);

export const mRect = (ctx: CanvasRenderingContext2D, d: number, y: number, w: number, h: number, color: string): void => {
  rect(ctx, CENTER - d - w, y, w, h, color);
  rect(ctx, CENTER + d, y, w, h, color);
};

export const mPx = (ctx: CanvasRenderingContext2D, d: number, y: number, color: string): void => {
  px(ctx, CENTER - d - 1, y, color);
  px(ctx, CENTER + d, y, color);
};

export const aRect = (ctx: CanvasRenderingContext2D, ax: number, y: number, w: number, h: number, color: string): void =>
  rect(ctx, ax - w / 2, y, w, h, color);
